import { queryOptions, useQuery } from '@tanstack/react-query';
import { ViewApi } from 'src/lib/api/loop-visualization/view';
import { viewQueryKeys } from '@/lib/query-keys/view';

export const getVisualizationViewsQueryOptions = ({ loopId }: { org?: string; loopId: number }) =>
  queryOptions({
    queryKey: viewQueryKeys.visualizationsView.list(loopId),
    queryFn: () => ViewApi.fetchViews(loopId),
    enabled: !!loopId,
  });

export const getVisualizationViewQueryOptions = ({ loopId }: { org?: string; loopId: number }) =>
  queryOptions({
    queryKey: viewQueryKeys.visualizationsView.details(loopId),
    queryFn: async () => {
      const views = await ViewApi.fetchViews(loopId);
      return views.length > 0 ? views[0] : null;
    },
    enabled: !!loopId,
  });

export const useVisualizationViews = (loopId: number) =>
  useQuery(getVisualizationViewsQueryOptions({ loopId }));

export const useVisualizationView = (loopId: number) => {
  return useQuery({
    ...getVisualizationViewQueryOptions({ loopId }),
    enabled: !!loopId,
  });
};
